<template>
  <div>
    <v-dialog scrollable v-model="value" max-width="800" persistent>
      <v-card>
        <v-card-text>
          <h2>
            กรุณาตรวจสอบขนส่งอีกครั้งก่อนยืนยันการทำรายการ ({{ ordersInModal.length }} รายการ)
          </h2>

          <v-checkbox
            v-if="resend"
            id="cbAll"
            :label="$t('Check all')"
            style="display: inline-block; margin: 0"
            v-model="checkboxAll"
            @change="clickCbAll"
            color="primary"
          ></v-checkbox>

          <template v-for="(order, index) in ordersInModal">
            <v-layout wrap :key="`packhai_${order.id}`">
              <v-flex xs12 sm3 class="py-2">
                <v-checkbox
                  v-if="resend"
                  :input-value="isCheck(order.id)"
                  :label="`Order No. ${order.id}`"
                  style="display: inline-block; margin: 0"
                  @change="assignCb(order.id)"
                  color="primary"
                  hide-details
                >
              </v-checkbox>
                <v-chip v-else small color="blue" class="white--text" disabled >Order No.: {{ order.id }}</v-chip>
                <p class="red--text text--lighten-1 text-error-over">{{ order.sendError }}</p>
              </v-flex>
              <v-flex xs12 sm5 class="pa-2">
                {{ order.nameaddress }}
              </v-flex>
              <v-flex xs12 sm4 class="text-xs-right pa-2"
                >{{ $t(order.shippingtype) }}
                <template v-if="order.shippingtype == 'cod_charge'">
                  <v-select
                    name="customshippingtype"
                    data-vv-as="ขนส่ง"
                    single-line
                    v-model="order.customshippingtype"
                    :items="shippingOptions"
                    outline
                    placeholder="เลือกขนส่ง"
                    v-validate="'required'"
                    :hide-details="!errors.has('customshippingtype')"
                    :error-messages="errors.first('customshippingtype')"
                  ></v-select>
                </template>
              </v-flex>
            </v-layout>
            <v-divider v-if="index != orders.length - 1" :key="`divider_${order.id}`" />
          </template>
          <div class="text-xs-center">
            <v-btn color="grey" outline :loading="loading" @click="close">{{ $t(resend?'cancel':'Back') }}</v-btn>
            <v-btn color="primary" :disabled="resend&&cbAll.length==0" depressed @click="confirmPackhai" :loading="loading">{{
              $t('Next')
            }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'orders'],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      addresses: 'getShippingAddress'
    })
  },
  data() {
    return {
      cbAll: [],
      checkboxAll: false,
      resend: false,
      ordersInModal:this.orders,
      loading: false,
      shippingOptions: [
        { value: 'bestexpress_charge', text: '(COD) ' + this.$t('bestexpress_charge') },
        { value: 'kerry_charge', text: '(COD) ' + this.$t('kerry_charge') },
        { value: 'ems_charge', text: '(COD) ' + this.$t('ems_charge') },
        { value: 'nim_charge', text: '(COD) ' + this.$t('nim_charge') },
        { value: 'flash_charge', text: '(COD) ' + this.$t('flash_charge') },
        { value: 'scgexpress_charge', text: '(COD) ' + this.$t('scgexpress_charge') },
        { value: 'jtexpress_charge', text: '(COD) ' + this.$t('jtexpress_charge') }
      ]
    }
  },
  methods: {
    isCheck(id) {
      if (this.cbAll && this.cbAll.length > 0) {
        return this.cbAll.includes(id)
      }
    },
    clickCbAll() {
      if (!this.cbAll.length) {
        this.cbAll = this.ordersInModal.map(v => v.id)
        this.checkboxAll = true
      } else {
        this.cbAll = []
        this.checkboxAll = false
      }
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter(v => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    close() {
      const vm = this
      if (this.resend) {
        window.location.reload()
      }else{
        vm.step = 1
        vm.$emit('input', false)
      }
    },
    async confirmPackhai() {
      const vm = this
      let result = await vm.$validator.validateAll()

      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        await vm.$swal({
          title: 'ข้อมูลไม่ครบถ้วนหรือไม่สามารถจัดส่งบางออเดอร์ได้',
          type: 'error',
          confirmButtonText: vm.$t('Confirm')
        })
        return false
      }
      vm.loading = true
      try {
        let updateordersError =[]
        let promises = vm.ordersInModal.filter((i)=>{
          if (vm.resend) { return vm.cbAll.includes(i.id) }
          return true
        }).map((order) => {
          // เปลี่ยนสถานะแล้วส่ง order ให้ packhai

          let body = { orderid: order.id }

          if (order.customshippingtype) body.new_shipping_type = order.customshippingtype

          return api.post_packhai_create_new_order({
            body: body,
            params: { pageid: vm.selectedBot.pageid }
          })
          .then((res)=>({...res,dataOrder:{...order,}}))
          .catch((err)=>({...err,dataOrder:order}))
        })
        let responses = await Promise.all(promises)

        try {
          let updateordersSuccess = responses.map(el => {
              if (el.success && el.result && el.result.orderid) return el.result.orderid
              return false
            }).filter(el => el !== false)

          updateordersError = responses.reduce((result,el)=>{
            if (!el.success && el.result && el.dataOrder.id){
              result = result.concat([{
                error_description:_.get(el,"result.error_description",el.message),
                orderID:el.dataOrder.id,
                dataOrder:el.dataOrder
              }])
            }
            return result
          },[])
          if (updateordersSuccess.length > 0 && updateordersError.length <= 0){
            vm.$emit('updateStatus', {
              orders: updateordersSuccess,
              oncomplete: () => {
                  vm.close()
                  window.location.reload()
                  vm.loading = false
                }
            })
          }
          if (updateordersError.length > 0) {
            vm.resend = true
            vm.loading = false
            vm.ordersInModal = vm.ordersInModal.reduce((result,itemOrder)=>{
              let dataRes = updateordersError.find(element => element.orderID == itemOrder.id);
              if (dataRes) {
                result = result.concat([{...itemOrder,sendError:_.get(dataRes,'error_description','')}])
              }else if(!updateordersSuccess.includes(itemOrder.id)){
                result = result.concat([{...itemOrder}])
              }
              return result
            },[])
            vm.cbAll = vm.ordersInModal.map(v => v.id)
            vm.checkboxAll = true
            await vm.$swal({
              title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
              text: '',
              type: 'error',
              confirmButtonText: vm.$t('Confirm')
            })
          }
        } catch (error) {
          vm.close()
          window.location.reload()
          vm.loading = false
        }
      } catch (error) {
        console.log(error)
        let text = ''

        await vm.$swal({
          title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
          text: text,
          type: 'error',
          confirmButtonText: vm.$t('Confirm')
        })

        vm.close()
        window.location.reload()
        vm.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-error-over{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PackhaiShipping.vue